import { SUPPORT_URL } from 'shared/constants/links';

/** Widget API Jivo (https://jivochat.com/docs/widget): виджет грузится асинхронно, поэтому `jivo_api` может не быть. */
declare global {
  interface Window {
    jivo_api?: { open: () => void };
  }
}

/**
 * Открыть чат поддержки поверх текущей страницы. Если виджет Jivo не загрузился (блокировщик, сеть),
 * открывает раздел контактов на лендинге в новой вкладке — пользователь не остаётся без способа написать.
 *
 * Экран вызывает её и про Jivo ничего не знает; чат грузит `JivoChatLoader` в шелле.
 */
export function openSupportChat(): void {
  if (typeof window.jivo_api?.open === 'function') {
    window.jivo_api.open();
    return;
  }

  window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer');
}
